import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { transformActions } from 'utils/';

/**
 * @description Custom hook to handle http status where `status` is `SUCCESS`, `FAILURE` or ALL
 * @param {{
 * actions: [],
 * status: string,
 * callBack: function,
 * resetCallBack: boolean
 * callBackOnSuccess: boolean
 * }} param
 */
function useHttpStatus({
  actions,
  callBack,
  status = 'SUCCESS',
  resetCallBack = false,
  callBackOnSuccess = false,
}) {
  const target = transformActions(actions, status);
  if (status === 'ALL') {
    const success = transformActions(actions, 'SUCCESS');
    const failure = transformActions(actions, 'FAILURE');
    target.push(...success, ...failure);
  }
  let { action, response } = useSelector(function ({ notify }) {
    return notify;
  });
  const positive = target.includes(action);
  const result = useMemo(() => {
    if (!positive) {
      response = null;
    }
    if (callBack && !callBackOnSuccess) {
      callBack(resetCallBack ? false : response);
    }
    return positive;
  }, [action, response]);
  if (result && callBack && callBackOnSuccess) {
    callBack(response);
  }
  return { result, response };
}

export default useHttpStatus;
